import { CHECKOUT_ROUTER } from '~/constants/router';
import { useSyncStorageEffect } from '~/hooks/reactQuery';
import { QUICK } from '~/hooks/useCartTypeParam';
import { openPageModal } from '~/utils/mobileApp';

const CommonStorageSyncWrapper = () => {
  // 배송지 없는 사용자가 바로구매 시, 배송지 입력 후 바로구매 페이지 이동
  useSyncStorageEffect((payload) => {
    if (payload === QUICK) openPageModal(CHECKOUT_ROUTER.quick);
  }, 'NOTIFY_ADD_NEW_ADDRESS');

  return <></>;
};

export default CommonStorageSyncWrapper;
